import { VideoSection } from "@/components/shared/video-section";
import { useUpdateProfileVideo } from "@/lib/api/user";

export function ProfileVideoSection({
  userId,
  videoUrl,
  disabled = false,
}: {
  userId: string;
  videoUrl?: string;
  disabled?: boolean;
}) {
  const updateProfileVideo = useUpdateProfileVideo(userId);

  return (
    <VideoSection
      title="Profile Video"
      videoUrl={videoUrl}
      disabled={disabled}
      onUpload={async (file) => {
        await updateProfileVideo.mutateAsync(file);
      }}
    />
  );
}
